<template style="padding-left:100px;" id="assign-role">
    <div class="role-container">
            <div class="d-flex w-99 m-auto p-3 justify-content-center flex-column role">
                <br/><br/><br/><br/>
                <h1>Assign Role</h1><hr>
                <div id="overlay" class="form-group col-lg-12" v-if="showMsgModal">
                   <div class="modal-dailog">
                      <div class="modal-content">
                        <div class="modal-body">
                          <h4 class="modal-title float-left mt-5" v-bind:style="{color:msgColor }">{{updateMsg}}</h4>
                            <button type="button" class="btn btn-primary text-justify" @click="showMsgModal=false;">OK</button>
                          </div>
                      </div>
                   </div>
                </div>

                <form action="#" method="post">
                    <div class="form-group mr-5">
                        <label class="float-left">User Name </label><br/>
                        <select v-model="userName" class="float-left ml-1">
                            <option v-for="ud in userData" :key="ud.syspk">{{ud.userName}}</option>
                        </select>
                    </div><br/><br/><br/>
                    <div class="form-group mr-5">
                        <label class="float-left">Role Name</label><br/>
                        <select v-model="roleName" class="float-left ml-1">
                            <option v-for="rd in roleData" :key="rd.roleId">{{rd.roleName}}</option>
                        </select>
                    </div>
                    <div id="overlay" class="form-group col-lg-12" v-if="showAddModal">
                       <div class="modal-dailog">
                          <div class="modal-content">
                              <h4 class="modal-title float-left mt-5">You are adding the role "{{roleName}}" <br/>for the user "{{userName}}". Please confirm.</h4>
                              <div class="modal-body p-4">
                                <button type="button" class="btn btn-primary mr-2 mb-5" @click="showAddModal=false; cancleData()">Cancel</button>
                                <button type="button" class="btn btn-success ml-2 mb-5" @click="showAddModal=false, showMsgModal=true, assignRole()">Confirm</button>
                              </div>
                          </div>
                       </div>
                    </div>
                    <br/><br/><br/><br/>
                    <button type="button" v-on:click="cancleData()" class="btn btn-primary mr-2 mb-5" >Cancel</button>
                    <button type="button" @click="showAddModal=true" class="btn btn-primary ml-2 mb-5" :disabled='(userName && roleName)==null'>Assign Role</button>
                </form>
            </div>
        </div>
</template>
<script>
import axios from 'axios'

export default {
    name: 'assignRole',
    data () {
      return {
        userData: null,
        roleData: null,
        userName: null,
        roleName: null,
        isDisabled: true,
        updateMsg: null,
        msgColor: null,
        showAddModal: false,
        showMsgModal: false,
      }
    },
    created: function () {
        this.getAllUserList()
        this.getAllRoleList()
    },
    methods: {
         getAllUserList: function () {
             axios.get('/api/user').then((response) => {
                   this.userData= response.data
                   console.log("User Data: ", this.userData)
             })
         },
         getAllRoleList: function () {
             axios.get('/api/role').then((response) => {
                   this.roleData= response.data
                   console.log("Role Data: ", this.roleData)
             })
         },
         cancleData: function() {
            this.userName= null,
            this.roleName= null
         },
         assignRole: function () {
            this.assignRoleFailed = false
            this.$store.state.authRequired = false
            var formData = {
                userName: this.userName,
                roleName: this.roleName
            };
            console.log("formData:", formData)
            axios.post(`/api/assign-role`, formData).then((response) => {
                console.log("this.data: ", response.data)
                this.updateMsg= 'New role assigned successfully'
                this.msgColor= 'green'
                this.userName= null,
                this.roleName= null
            }, error => {
                  this.updateMsg= error.response && error.response.data ? error.response.data.title : ''
                  this.msgColor= 'red'
                  this.errorTitle = error.response && error.response.data ? error.response.data.title : ''
                  if(!this.assignRoleFailed) {
                      console.log("this.assignRoleFailed", this.assignRoleFailed)
                      this.updateMsg= 'This role is already assigned for the current user.'
                      this.msgColor= 'red'
                  }
                  this.$store.commit('authError')
                  this.assignRoleFailed = !this.$store.state.serverIsDown
                  this.userName= null,
                  this.roleName= null
            })
         }
    }
  }
</script>
<style scoped>
    .role-container {
        display: flex;
        width: 100vh;
        height: 75vh;
        justify-content: center;
        align-content: center;
        align-items: center;
        align-self: center;
    }
    .role { box-shadow: 1px 2px 2px 3px #a7aeaa; }
    .btn.btn[disabled] { color: black; }
    select, option {
        width:290px;
        height: 35px;
    }

    option {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    #overlay {
        width: 30%;
        height: 100%;
        align-content: left;
        position: fixed;
        bottom: 0;
        top: 20%;
        left: 15%;
        right: 0;
        margin-left: 28%;
        margin-top: 1%;
    }
</style>